import React from 'react';
import { KPIArticleList, KPIArticle } from '../../../../Components/KPI/KPI';
import { useDataVizContext } from '../../context/ContextDataViz';
import { getFormattedNumber } from '../../../../Util/numberFormats';
import styles from '../../kpi.module.css';

export default function DataGlobal() {
	const {
		dataVizAggregate,
		noDataForAccount,
		isLoading
	} = useDataVizContext();

	if(noDataForAccount && !isLoading ) return <></>;

	return (
		<KPIArticleList className={styles.section_part}>
			<KPIArticle
				isLoading={isLoading}
				label={'Total sessions count'}
				value={getFormattedNumber(dataVizAggregate?.totalSessionCount)}
			/>
			<KPIArticle
				isLoading={isLoading}
				label={'Total converted sessions'}
				value={getFormattedNumber(dataVizAggregate?.totalConvertedSessionCount)}
			/>
			<KPIArticle
				isLoading={isLoading}
				label={'Total turnover count'}
				value={getFormattedNumber(dataVizAggregate?.totalTurnover, 2, '€')}
			/>
		</KPIArticleList>
	);
}
